import { Outlet } from 'react-router'

export default function UserNameRoute() {
	return <Outlet />
}
